import { ErrorContext } from '@portals/shared-frontend/hooks';
import { type JSX, ReactNode, useContext } from 'react';

import { GlobalErrorPage } from '@/components/ErrorBoundary/GlobalErrorPage';

export function ErrorBoundary({ children }: { children: ReactNode }): JSX.Element {
  const { globalError } = useContext(ErrorContext);

  if (globalError) return <GlobalErrorPage errorCode={globalError} />;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
